import { gql } from '@apollo/client';

export const DAMAGE_CLAIM_FIELDS_FOR_ADMIN = gql`
  fragment DamageClaimFieldsForAdmin on DamageClaim {
    id
    shortId
    claimNum
    bookingId
    reporterId
    hostId
    guestId
    carId
    status
    damageType
    physicalDamageSubcategory
    beforePhotos
    afterPhotos
    policeReportFiled
    waterInsideCar
    whoWasDriving
    anyoneInjured
    anotherPersonInvolved
    isCarDriveable
    didVehicleLoseFluids
    didAirbagsDeploy
    incidentOccurredAt
    incidentLocation {
      country
      streetAddress
      city
      postalCode
    }
    damagedParts
    damagedPartsOtherDescription
    mechanicalIssues
    mechanicalIssueOtherDescription
    damageDescription
    additionalInfo
    repairShopInfo {
      shopName
      address
      contactName
      phoneNumber
    }
    repairEstimateRange
    claimAmount
    approvedAmount
    hostClaimAmount
    guestShouldPay
    protectionPlanSnapshot {
      planId
      planType
      planName
      dailyPrice
      outOfPocket
      description
      policyDetails
      snapshotAt
    }
    rejectionReason
    depositPaymentIntentId
    adminNotes
    reviewedBy
    reviewedAt
    response {
      responseContent
      responsePhotos
      responderId
      createdAt
    }
    responderId
    counterpartyReviewed
    responseDeadline
    createdAt
    updatedAt
  }
`;

export const GET_ALL_DAMAGE_CLAIMS = gql`
  query GetAllDamageClaims($status: String) {
    allDamageClaims(status: $status) {
      ...DamageClaimFieldsForAdmin
      booking {
        id
        startAt
        endAt
        car {
          id
          make
          model
          year
          thumbnailUrl
        }
        guest {
          id
          firstName
          lastName
          displayName
          email
          phoneNumber
        }
        host {
          id
          firstName
          lastName
          displayName
          email
        }
      }
      reporter {
        id
        firstName
        lastName
        displayName
      }
    }
  }
  ${DAMAGE_CLAIM_FIELDS_FOR_ADMIN}
`;

export const GET_DAMAGE_CLAIM_FOR_ADMIN = gql`
  query GetDamageClaimForAdmin($id: String!) {
    damageClaim(id: $id) {
      ...DamageClaimFieldsForAdmin
      booking {
        id
        startAt
        endAt
        securityDepositAmount
        securityDepositStatus
        car {
          id
          make
          model
          year
          thumbnailUrl
        }
        guest {
          id
          firstName
          lastName
          displayName
          email
          phoneNumber
        }
        host {
          id
          firstName
          lastName
          displayName
          email
        }
      }
      reporter {
        id
        firstName
        lastName
        displayName
      }
    }
  }
  ${DAMAGE_CLAIM_FIELDS_FOR_ADMIN}
`;

export const UPDATE_DAMAGE_CLAIM_STATUS = gql`
  mutation UpdateDamageClaimStatus($input: UpdateDamageClaimStatusInput!) {
    updateDamageClaimStatus(input: $input) {
      ...DamageClaimFieldsForAdmin
    }
  }
  ${DAMAGE_CLAIM_FIELDS_FOR_ADMIN}
`;

export const ADD_DAMAGE_CLAIM_NOTES = gql`
  mutation AddDamageClaimNotes($input: AddAdminNotesInput!) {
    addDamageClaimNotes(input: $input) {
      ...DamageClaimFieldsForAdmin
    }
  }
  ${DAMAGE_CLAIM_FIELDS_FOR_ADMIN}
`;
